import { PayloadAction } from '@reduxjs/toolkit';
import { WritableDraft } from 'immer';

import { QuoteBuilderStateType } from '../../types/state';
import { QuoteLineConfiguratorSnapshotType } from '../../types/state/internal';

export function quoteLineEditedInConfigurator(
  state: WritableDraft<QuoteBuilderStateType>,
  action: PayloadAction<QuoteLineConfiguratorSnapshotType>,
) {
  const {
    lineNumber,
    quoteLineUuid,
    form,
    configurationId,
    quantity,
    customerPartId,
  } = action.payload;
  state.quoteLineConfiguratorSnapshot = {
    form,
    configurationId,
    lineNumber,
    quoteLineUuid,
    quantity,
    customerPartId,
  };
  state.dialog = {
    name: 'configurator',
  };
}

export function quoteLineEditedInConfiguratorClosed(
  state: WritableDraft<QuoteBuilderStateType>,
) {
  state.dialog = null;
  state.quoteLineConfiguratorSnapshot = null;
}
